import React from 'react';
import PropTypes from 'prop-types';
import { StyledIcon } from './style';

const Icon = props => {
  const Tabindex = props.hover ? '0' : '-1';
  const Role = props.hover ? 'button' : '';

  return (
    <StyledIcon
      className={props.className}
      color={props.color}
      id={props.id}
      size={props.size}
      svg={props.svg}
      onClick={props.onClick}
      tabIndex={Tabindex}
      role={Role}
      expanded={props.expanded}
      haspopup={props.haspopup}
      hover={props.hover}
      width={props.width}
      height={props.height}
    />
  );
};

Icon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'dark',
    'grayDark',
    'grayDarker',
    'light',
    'error',
    'success',
    'warning',
    'info',
    'main'
  ]),
  hover: PropTypes.bool,
  size: PropTypes.oneOf(['xxs', 'xs', 's', 'sm', 'smm', 'm', 'l', 'xl']),
  svg: PropTypes.shape({
    viewBox: PropTypes.string,
    url: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  id: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

Icon.defaultProps = {
  color: 'dark',
  hover: false
};

export default Icon;
